import React from "react";
import moment from "moment";
import config from "../../config";
import Currency from "./Currency";

const TransactBefore = ({expiration_date, transact_from, tier_treshold}) => {
    const today = moment.utc(new Date());
    const moment_expiration_date = moment(expiration_date);
    const moment_start_date = moment(transact_from);
    const duration = moment.duration(moment_expiration_date.diff(today));
    const months = duration.asMonths();

    return (
        <>
            <span className={months <= 2 ? "acc-rebag-rewards__text acc-rebag-rewards__text--red" : ""}>Transact <Currency value={tier_treshold}/> between {moment(moment_start_date).format('MM/DD/YY')} and {moment(expiration_date).format('MM/DD/YY')} to maintain your Rebag Rewards tier.</span> <a
                href={`${config.host_rebag}/rewards`}
                className="rbg-link rbg-link--inline acc-rebag-rewards__text"
                target="_blank"
                rel="noopener noreferrer"
            >
                Find Out More
            </a>
        </>
    )
}

export default TransactBefore;